<div class="primary-label mb-4 flex items-center">
  <button aria-label="Back" class="flex p-1 mr-5" (click)="goBack.emit(true)">
    <mat-icon
      class="w-[24px] h-[24px] text-[24px] material-icons-outlined bg-none"
      >arrow_back</mat-icon
    >
  </button>

  <h1 class="text-[24px] leading-8 bg-none">
    <ng-content></ng-content>
  </h1>
</div>
